import { cn } from "@newxsystems/shared";
import { DaylightAction } from "../DaylightAction/DaylightAction";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";

const widths = { small: "w-1/2", medium: "w-3/4", large: "w-full" } as const;

export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div
      className={cn("relative z-10 flex flex-col gap-5", centered && "items-center text-center")}
    >
      {eyebrow ? (
        <p className="flex items-center gap-3 font-daylight-body text-sm font-semibold before:h-px before:w-8 before:bg-current">
          {eyebrow}
        </p>
      ) : null}
      {image ? (
        <DaylightMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn(
            "my-4 border-[10px] border-daylight/20 md:rotate-1",
            widths[imageWidth || "medium"],
          )}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2 className="max-w-[14ch] break-words font-daylight-display text-[clamp(2.25rem,5.5vw,3.75rem)] font-semibold leading-[0.98] tracking-[-0.035em]">
          {heading}
        </h2>
      ) : null}
      {description ? (
        <DaylightRichText className="max-w-[65ch] text-mineral-gray" content={description} />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-3", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <DaylightAction
              action={button}
              className="border-mineral-gray text-mineral-gray"
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

CallToActionStacked.displayName = "Content::CallToActionStacked";
